module.exports = __webpack_public_path__ + "media/images/pic/brodno/join-us-b3f2f72c2ea07ce475bc6daf64d14af3.jpg";